import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import { crd } from "../../constants/styles";
import Ic from "../common/Ic";
import ChatBox from "./ChatBox";

function ChatListPage() {
  const { t, h, props, tens, go, setSelPropId, openChat, setOpenChat } = useContext(Ctx);
  if (openChat) {
    const op = props.find(x => x.id === openChat); const te = tens.find(x => x.id === op?.tid);
    return <div style={{ paddingTop: 16 }}><button onClick={() => setOpenChat(null)} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back}</button>
      <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, marginBottom: 16 }}>{t.chat} - {te?.name}</h2><ChatBox pid={openChat} sender="ll" /></div>;
  }
  return <div style={{ paddingTop: 16 }}><h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, marginBottom: 16 }}>{t.chat}</h2>
    {props.filter(p => p.occ).map(p => {
      const te = tens.find(x => x.id === p.tid); return <div key={p.id} onClick={() => setOpenChat(p.id)} style={{ ...crd(h), cursor: "pointer", display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ width: 40, height: 40, borderRadius: 20, background: h.ac, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, flexShrink: 0 }}>{te?.name[0]}</div>
        <div><div style={{ color: h.tx, fontWeight: 600, fontSize: 13 }}>{te?.name}</div><div style={{ color: h.sc, fontSize: 11 }}>{p.addr}</div></div>
        <div style={{ marginLeft: "auto" }}><Ic n="msg" s={18} c={h.sc} /></div></div>;
    })}
  </div>;
}

export default ChatListPage;
